import TradersListPage from "./TradersListPage";

/** Unverified users route — data from GET /v1/admin/users/unverified. */
const UnverifiedTradersListPage = () => <TradersListPage variant="unverified" />;

export default UnverifiedTradersListPage;
